// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { Container, Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import TitleWithBack from '../components/common/TitleWithBack';
import './ForgotPassword'

function ForgotPassword() {
  // Step 1: Request Reset; Step 2: Reset with OTP; Step 3: Success message.
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleRequestReset = async () => {
    setError('');
    setMessage('');
    if (!email.trim()) {
      setError('Please enter your email.');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/password-reset/request', { email });
      setMessage('An OTP has been sent to your email.');
      setStep(2);
    } catch (err) {
      setError('Error requesting password reset.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    setError('');
    setMessage('');
    if (!email.trim() || !otp.trim() || !newPassword.trim()) {
      setError('Please fill in all fields.');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/password-reset/reset', {
        email,
        otp,
        newPassword
      });
      setMessage('Password reset successful. You may now log in.');
      setStep(3);
    } catch (err) {
      setError('Error resetting password.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-2" style={{ maxWidth: '500px' }}>
      <TitleWithBack title="Forgot Password" />
      
      {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
      {message && <Alert variant="success" className="mt-3">{message}</Alert>}
      {loading && <div className="my-3 text-center"><Spinner animation="border" variant="primary" /></div>}

      {step === 1 && (
        <>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control 
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" onClick={handleRequestReset} disabled={loading}>
            Request Password Reset
          </Button>
        </>
      )}

      {step === 2 && (
        <>
          <Form.Group className="mb-3" controlId="formOtp">
            <Form.Label>OTP</Form.Label>
            <Form.Control 
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formNewPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="off"
              data-lpignore="true"
              data-1p-ignore="true"
              data-form-type="other"
            />
          </Form.Group>
          <Button variant="primary" onClick={handleResetPassword} disabled={loading}>
            Reset Password
          </Button>
        </>
      )}

      {step === 3 && (
        <>
          <Alert variant="success" className="mt-3">
            Your password has been reset successfully.
          </Alert>
          <Button variant="primary" onClick={() => window.location.href = '/login'}>
            Go to Login
          </Button>
        </>
      )}
    </Container>
  );
}

export default ForgotPassword;
